import { AxiosResponse } from 'axios'
import { GET_API_TOKEN, API_BASE_URL } from '../../constants/apiConstants'
import { LOCAL_TIME_ZONE } from '../../constants/defaults'
import axios from '../../helpers/Axios'
import { RecordedSensorDataForCsvResponse } from '../../types/SensorType'
const baseUrl = API_BASE_URL


export const getRecordedData = async (
  patientKey: string,
  startTime: number,
  endTime: number
): Promise<object> => {
  return axios({
    method: 'get',
    baseURL: baseUrl,
    url: `/api/rpmweb/sensors/recorded/${patientKey}/${startTime}/${endTime}?timeZone=${LOCAL_TIME_ZONE}`,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}
export const getRecordedDataFile = async (
  patientKey: string,
  startTime: number,
  endTime: number
): Promise<AxiosResponse<RecordedSensorDataForCsvResponse | undefined>> => {
  return axios({
    method: 'get',
    baseURL: baseUrl,
    url: `/api/rpmweb/sensors/recorded/csv/${patientKey}/${startTime}/${endTime}?timeZone=${LOCAL_TIME_ZONE}`,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}

export const getSensorConnection = async (patientKey: string, limit = 1) => {
  return axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: `/api/rpmweb/sensors/${patientKey}/connection?timeZone=${LOCAL_TIME_ZONE}`,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  }).then((response) => {
    let connectionDetails = response.data?.data?.patientConnectionDetails[0] || null;

    if (connectionDetails && connectionDetails.deviceStatus === "ONLINE" && !connectionDetails.endTime) {
      connectionDetails.endTime = Date.now();
    }

    return connectionDetails;
  });
};